import { render } from "./tablaAccionesMultiples.vue?vue&type=template&id=18d29d1a"
import script from "./tablaAccionesMultiples.vue?vue&type=script&lang=js"
export * from "./tablaAccionesMultiples.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__